import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, Flower2 } from "lucide-react";
export default function IntroducciNSbc() {
  return <section data-section-id="262843" id="introducción-sbc" className="w-full flex flex-col bg-background text-foreground">
      {}
      <div className="grid grid-cols-1 lg:grid-cols-2 w-full">
        {}
        <div className="relative min-h-[400px] lg:min-h-[600px] w-full bg-accent">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/sbc_security_infrastructure.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/sbc_security_infrastructure.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/sbc_security_infrastructure.png-wvc-sizes" alt="Infraestructura de seguridad VoIP" className="absolute inset-0 w-full h-full object-cover opacity-90" loading="lazy" />
          <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/grid-me.png')] opacity-20 pointer-events-none"></div>
        </div>

        {}
        <div className="flex flex-col justify-center p-8 md:p-16 lg:p-24 bg-accent/30 backdrop-blur-sm animate-in fade-in duration-1000">
          <div className="max-w-xl">
            <span className="block text-sm font-semibold tracking-[0.2em] uppercase mb-4 text-primary font-default">
              Seguridad empresarial
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-6 text-foreground leading-tight">
              Controlador de Borde de Sesión <span className="text-primary">SBC</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-10 leading-relaxed font-default">
              Seguridad empresarial para infraestructura VoIP basada en software. Proteja sus comunicaciones con la tecnología más avanzada del mercado.
            </p>
            <Link to="#">
              <Button variant="default" size="lg" className="uppercase font-bold tracking-wider bg-chart-4 text-black hover:bg-chart-4/90 rounded-md shadow-md">
                Solicitar Demostración
                <ArrowRight className="ml-2 size-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="bg-primary text-primary-foreground py-16 px-6 md:px-12 flex flex-col items-center text-center">
        <Flower2 className="size-10 mb-6 opacity-90" />
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold uppercase font-default mb-4 tracking-wide">
          Infraestructura Robusta y Escalable
        </h3>
        <p className="text-lg md:text-xl text-primary-foreground/90 font-medium font-default">
          Interoperabilidad. Seguridad. Calidad de Servicio. Control.
        </p>
      </div>
    </section>;
}